module.exports = __webpack_public_path__ + "img/bekabeling_2.19d73f87.png";